import React from 'react';
import { Icon as IconifyIcon } from '@iconify/react';

const VendedorDetalhePedido = ({ order }) => {
  return (
    <div className='dp-info-card'>
      <span className='dp-info-card-title'>Informações do Fornecedor</span>

      <div className='dp-info-card-name'>{order.resaleName}</div>

      {order.salesMan?.phone && (
        <div className='dp-info-card-row'>
          <span className='dp-info-card-row-icon'>
            <IconifyIcon
              icon='fa6-solid:phone'
              style={{ width: 14, height: 14 }}
            />
          </span>
          <span className='dp-info-card-row-link'>{order.salesMan.phone}</span>
        </div>
      )}

      {order.salesMan?.email && (
        <div className='dp-info-card-row'>
          <span className='dp-info-card-row-icon'>
            <IconifyIcon
              icon='fa6-solid:envelope'
              style={{ width: 14, height: 14 }}
            />
          </span>
          <span className='dp-info-card-row-text'>{order.salesMan.email}</span>
        </div>
      )}

      {order.salesMan?.name && (
        <div className='dp-info-card-row'>
          <span className='dp-info-card-row-icon'>
            <IconifyIcon
              icon='fa6-solid:user'
              style={{ width: 14, height: 14 }}
            />
          </span>
          <span className='dp-info-card-row-text'>{order.salesMan.name}</span>
        </div>
      )}
    </div>
  );
};

export default VendedorDetalhePedido;
